import {MapPin, Phone, Mail, Instagram, Facebook, Linkedin, ArrowRight} from 'lucide-react';

const navLinks = [
  { label: "A Empresa",  href: "#empresa"  },
  { label: "Produtos",   href: "#produtos" },
  { label: "Serviços",   href: "#servicos" },
  { label: "Catálogo",   href: "#catalogo" },
  { label: "Contato",    href: "#contato"  },
];

const productLinks = [
  "Mangueiras Hidráulicas",
  "Conexões e Terminais",
  "Correias Industriais",
  "Componentes Pneumáticos",
  "EPIs e Segurança",
];

export default function Footer() {
  const scrollTo = (href: string) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="bg-[#08112b] text-gray-400 relative overflow-hidden">

      {/* Gold top line */}
      <div className="h-1 w-full bg-gradient-to-r from-transparent via-[#F5A623] to-transparent opacity-60" />

      {/* Ambient glows */}
      <div className="absolute top-0 left-0 w-[24rem] h-[24rem] bg-[#F5A623]/4 rounded-full blur-[80px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[20rem] h-[20rem] bg-[#F5A623]/3 rounded-full blur-[80px] pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-10">

        {/* ── Main grid ── */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/8">

          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.lumi.new/43/43ff0b69169020285ea7cce93ddc1584.webp"
              alt="Manguenela Rio"
              className="h-20 md:h-24 w-auto object-contain mb-5 drop-shadow-xl"
            />
            <p className="text-sm leading-relaxed text-gray-400 mb-6 max-w-xs">
              Especialistas em mangueiras hidráulicas, conexões e soluções industriais para todos os segmentos do mercado.
            </p>
            <div className="flex gap-3">
              {[
                { icon: Instagram, href: "#", label: "Instagram" },
                { icon: Facebook, href: "#", label: "Facebook" },
                { icon: Linkedin, href: "#", label: "LinkedIn" },
              ].map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  className="w-10 h-10 rounded-xl bg-white/5 hover:bg-[#F5A623]/15 hover:text-[#F5A623] flex items-center justify-center border border-white/8 hover:border-[#F5A623]/30 transition-all duration-200"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Nav */}
          <div>
            <h4 className="text-white font-black text-xs uppercase tracking-[0.2em] mb-5">Navegação</h4>
            <ul className="flex flex-col gap-2.5">
              {navLinks.map(({ label, href }) => (
                <li key={href}>
                  <button
                    onClick={() => scrollTo(href)}
                    className="flex items-center gap-1.5 text-sm hover:text-[#F5A623] transition-colors duration-200 group"
                  >
                    <ArrowRight size={12} className="opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all text-[#F5A623]" />
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-black text-xs uppercase tracking-[0.2em] mb-5">Produtos</h4>
            <ul className="flex flex-col gap-2.5">
              {productLinks.map((product) => (
                <li key={product}>
                  <button
                    onClick={() => scrollTo("#produtos")}
                    className="flex items-center gap-1.5 text-sm hover:text-[#F5A623] transition-colors duration-200 group text-left"
                  >
                    <ArrowRight size={12} className="opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all text-[#F5A623]" />
                    {product}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-black text-xs uppercase tracking-[0.2em] mb-5">Contato</h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <MapPin size={15} className="text-[#F5A623] mt-0.5 shrink-0" />
                <span className="text-sm leading-relaxed">CPO São Cristóvão, 388<br />Rio de Janeiro · CEP 20.921-440</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={15} className="text-[#F5A623] shrink-0" />
                <a href="https://wa.me/5521973516085" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-[#F5A623] transition-colors">
                  (21) 97351-6085
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={15} className="text-[#F5A623] mt-0.5 shrink-0" />
                <div className="flex flex-col gap-1">
                  <a href="mailto:suporte@manguenela.com.br" className="text-sm hover:text-[#F5A623] transition-colors">
                    suporte@manguenela.com.br
                  </a>
                  <a href="mailto:administrativo@manguenela.com.br" className="text-sm hover:text-[#F5A623] transition-colors">
                    administrativo@manguenela.com.br
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-600">
          <p>© {new Date().getFullYear()} Manguenela Rio LTDA · CNPJ: 66.762.587/0001-84 · Todos os direitos reservados.</p>
          <p className="text-gray-700">São Cristóvão, Rio de Janeiro – RJ</p>
        </div>
      </div>
    </footer>
  );
}
